import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=1c330026&"
import script from "./Tags.vue?vue&type=script&lang=js&"
export * from "./Tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports